<div class="p-5" style="width: 700px; max-width: 95vw;">
    <div class="flex justify-between items-center mb-2">
        <div class="text-lg text-gray-700 font-bold">Filtros avançados</div>
        <button class="btn-icon" (click)="close()"><mat-icon>close</mat-icon></button>
    </div>

    <div [formGroup]="form" class="mt-2">
        <div class="flex flex-row justify-between items-center w-full">
            <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Data Inicio</mat-label>
                <input matInput [matDatepicker]="dateInitial" formControlName="dateInitial" />
                <mat-datepicker-toggle matSuffix [for]="dateInitial"></mat-datepicker-toggle>
                <mat-datepicker #dateInitial></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Data Fim</mat-label>
                <input matInput [matDatepicker]="dateEnd" formControlName="dateEnd" />
                <mat-datepicker-toggle matSuffix [for]="dateEnd"></mat-datepicker-toggle>
                <mat-datepicker #dateEnd></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="flex flex-row justify-between items-center w-full">
            <mat-form-field class="input-tg w-6/12 px-2" appearance="outline">
                <mat-label>Cliente</mat-label>
                <input matInput formControlName="cliente" readonly />
                <button mat-icon-button matSuffix (click)="addClient()">
                    <mat-icon>add</mat-icon>
                </button>
            </mat-form-field>
            <mat-form-field class="input-tg w-6/12 px-2" appearance="outline">
                <mat-label>Consultor operacional</mat-label>
                <input matInput formControlName="consultor" readonly />
                <button mat-icon-button matSuffix (click)="addConsultor()">
                    <mat-icon>add</mat-icon>
                </button>
            </mat-form-field>
        </div>

        <div class="flex flex-row justify-between items-center w-full">
            <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Fornecedor</mat-label>
                <mat-select formControlName="fornecedorId">
                    <mat-option [value]="null">Todos</mat-option>
                    <mat-option *ngFor="let fornecedor of listFornecedores" [value]="fornecedor.id">
                        {{ fornecedorLabel(fornecedor) }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Tipo de fornecedor</mat-label>
                <mat-select formControlName="tipoFornecedor">
                    <mat-option [value]="null">Todos</mat-option>
                    <mat-option value="frota_propria">Frota própria</mat-option>
                    <mat-option value="parceiro">Parceiro</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="flex items-center gap-6 px-2 mb-3">
            <mat-checkbox formControlName="semMotorista">Sem motorista</mat-checkbox>
            <mat-checkbox formControlName="comOcorrencia">Com ocorrência</mat-checkbox>
        </div>
    </div>

    <div class="flex justify-end items-center gap-2 mt-4">
        <button class="btn-icon" (click)="resetForm()" matTooltip="Limpar filtros"><mat-icon>replay</mat-icon></button>
        <button mat-flat-button class="btn-tg" (click)="search()">Filtrar</button>
    </div>
</div>
